export interface IRelationshipForm {
  relationship: string | null;
}

export const RELATIONSHIP_OPTIONS = [
  'Married',
  'Civil Partnership',
  'Partner (not married)',
  'Siblings',
  'Friends',
  'Parent and child',
  'Other',
];
